"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgFlag(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M8.642.494l.568.119.599.138.633.157.67.176 1.719.47.593.153.276.068.515.12c.083.019.163.037.243.053l.46.091c.148.027.292.051.433.073l.417.056c.274.032.544.055.82.069 2.032.103 3.748-.401 5.356-1.72a.737.737 0 01.556-.25.75.75 0 01.743.648l.007.102v11.014a.75.75 0 01-.269.575c-1.933 1.618-4.043 2.252-6.469 2.129-.384-.02-.752-.053-1.13-.103l-.46-.068a15.951 15.951 0 01-.235-.041l-.492-.096-.526-.117-.57-.138-.958-.25-1.413-.388-.647-.17-.607-.15c-.49-.118-.94-.215-1.356-.29l-.485-.08c-1.968-.293-3.164-.036-4.382.884L3.25 23a.75.75 0 01-1.493.102L1.75 23V2.482l.002-.059a.75.75 0 01.269-.633C3.924.21 5.606-.103 8.642.494zM3.251 2.728v9.205c1.47-.817 3.017-.905 5.391-.439l.568.119.599.138.633.157.67.176 1.719.47.593.153.276.068.515.12c.083.019.163.037.243.053l.46.091c.148.027.292.051.433.073l.417.056c.274.032.544.055.82.069 1.951.099 3.61-.362 5.162-1.565V2.49c-1.594.965-3.316 1.342-5.238 1.245-.384-.02-.752-.053-1.13-.103l-.46-.068a15.952 15.952 0 01-.235-.041l-.492-.096-.526-.117-.57-.138-.958-.25-1.413-.388-.647-.17-.607-.15c-.49-.118-.94-.215-1.356-.29l-.485-.08c-1.968-.293-3.164-.036-4.382.884z"
  }));
}

var _default = SvgFlag;
exports.default = _default;